/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {useEffect, useState} from 'react';
import { Routes, Route } from "react-router";
import {BrowserRouter, Navigate} from "react-router-dom";
import Navbar from "./Navbar";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Homepage from '../homepage/Homepage';
import SegnalazioneCreate from '../stor-create/SegnalazioneCreate';
import SegnalazioneDetail from '../stor-details/SegnalazioneDetail';
import { Setting } from '../../shared/utils/Settings';
import User from '../../services/models/output-objs/User';
import CustomSpinner from '../../shared/atomic_components/spinner/CustomSpinner';
import { UserInfo } from '../../services/models/output-objs/UserInfo';
import { SegnalazioniService } from '../../services/controllers/segnalazioni-services/SegnalazioniService';
import { GetCatalogList, getForeignAuthorities, getMacroCategories, getSuspectInternal } from '../../services/controllers/catalogs-services/CatalogsStructureService';
import CONSTANTS from '../../shared/utils/Constants';
import ConfigTab from './ConfigTab';
import ConfigDashboard from './ConfigMenu';


const Alert = React.forwardRef(function Alert(props: any, ref: any) {
    return <MuiAlert elevation={6} ref={ref} {...props} />;
});

const MasterPage = () => {

    const [user, setUser] = useState<User>(setUserFromToken());
    const [refreshUser,setrefreshUser] = useState<boolean>(false);
    const [notificationOpen, setNotificationOpen] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState("")
    const [notificationSeverity, setNotificationSeverity] = useState("success")
    const [userInfo, setUserInfo] = useState<UserInfo>({})
    const [isLoading, setLoading] = useState(true);
    const [notificationFunctions, setNotificationsFunctions] = useState({
        setErrorMessage: setErrorMessage,
        setSuccessMessage: setSuccessMessage,
        setWarningMessage: setWarningMessage
    })
    const segnalazioniService : SegnalazioniService = new SegnalazioniService();


    useEffect(() => {
        getuserInfoEffect()
        getCatalogue()
    }, [])

    useEffect(() => {}, [refreshUser]) 

    async function getuserInfoEffect(){
        const response = await segnalazioniService.getUserInfo();
        setUserInfo(response)
        setLoading(false)
    }

    async function getCatalogue(){
        const res = await GetCatalogList(user.ldapSource);
        sessionStorage.setItem('catalogueList', JSON.stringify(res))
    }

    function setUserFromToken(){
        const parsedJWT = parseJWTToken(localStorage.getItem('accessToken'));
        if(parsedJWT.ldapSource?.toLowerCase().includes(CONSTANTS.internalUserRole) && parsedJWT.groups &&  parsedJWT.groups.length>0){
            parsedJWT.groups.map((group : string) =>{
                if(group === '/STOR-User' || group === '/STOR-Admin'){
                    parsedJWT.selectedGroup = 'deskStor'
                }
            })
            if(!parsedJWT.selectedGroup){
                switch(parsedJWT.groups[0]){
                    case "/STOR-RDU" : parsedJWT.selectedGroup = 'responsabile'; break;
                    case "/STOR-Funz" : parsedJWT.selectedGroup = 'funzionario'; break;
                    case "/STOR-REV" : parsedJWT.selectedGroup = 'revisore'; break;
                }
            }
        }
        return parsedJWT
    }

    function parseJWTToken(token: any) {

        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(jsonPayload);
    }

    function setErrorMessage(message: any) {
        setNotificationOpen(true)
        setNotificationSeverity('error')
        setNotificationMessage(message)
    }

    function setSuccessMessage(message: any) {
        setNotificationOpen(true)
        setNotificationSeverity('success')
        setNotificationMessage(message)
    }

    function setWarningMessage(message: any) {
        setNotificationOpen(true)
        setNotificationSeverity('warning')
        setNotificationMessage(message)
    }

    const handleClose = (event: any, reason: any) => {
        if (reason === 'clickaway') {
            return;
        }
        setNotificationOpen(false);
    };

    return (
        <>
            {<Snackbar
                autoHideDuration={Setting.ALERT_TIMEOUT}
                open={notificationOpen}
                onClose={handleClose}
                anchorOrigin={{vertical: 'top', horizontal: 'center'}}>
                <Alert onClose={handleClose} severity={notificationSeverity}>
                    {notificationMessage}
                </Alert>
            </Snackbar>}
            <Navbar user={user} refreshToken={refreshUser} refreshUserCallBack={setrefreshUser} userCallBack={setUser}/>
            <CustomSpinner></CustomSpinner>
            {isLoading?  <></> :
                <BrowserRouter basename='/stor-fe'>
                    <div className="page-container mb-5">
                        <Routes>
                            <Route path="/" element={<Navigate to="/homepage"/>}/>
                            <Route path="/homepage" element={<Homepage notificationFunctions={notificationFunctions} user={user} refresh={refreshUser}/>} />
                            <Route path="/stor/create" element={<SegnalazioneCreate notificationFunctions={notificationFunctions} user={user} userInfo={userInfo} />} />
                            <Route path="/stor/detail" element={<SegnalazioneDetail notificationFunctions={notificationFunctions} user={user}/>} />
                            <Route path="/gestione" element={<ConfigDashboard></ConfigDashboard>} />

                        </Routes>
                    </div>
                </BrowserRouter>
            }
        </>
    )
}

export default MasterPage;
